import gql from 'graphql-tag';

const GET_USERS = gql`
  query users($where: UserListWhereInput) {
    users(where: $where) {
      id
      name
      email
      role
    }
  }
`;

const ADD_USER = gql`
  mutation createUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      name
      email
      role
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateUser($where: UserWhereUniqueInput!, $data: UpdateUserInput!) {
    updateUser(where: $where, data: $data) {
      id
      name
      email
      role
    }
  }
`;

export { GET_USERS, ADD_USER, UPDATE_USER };
